var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFactory = function SvgIconFactory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#422800",
    d: "M0 15V5.981L5.25 3.75v1.5L9 3.75V6h6v9H0Zm1.5-1.5h12v-6h-6V5.963l-3.75 1.5V6l-2.25.994V13.5ZM6.75 12h1.5V9h-1.5v3Zm-3 0h1.5V9h-1.5v3Zm6 0h1.5V9h-1.5v3ZM15 6h-3.75L12 0h2.25L15 6Z"
  })));
};
export default SvgIconFactory;